export default __webpack_public_path__ + "e38e6a2e8ed4e14a0c511e6501bb9961.png";